// import React, { useEffect, useState } from 'react';
// import { MOBILE_VERFIY_SEND, MOBILE_SEND_VERFIY, PARTNER_REGISTER, JOIN_US_PANCARD_VERIFY, CREATE_USER_AADHARCARD_VERIFY, CREATE_USER_AADHARCARD_OTP_VERIFY } from './../Utils/appConstants';
// import { postRequest, getRequest } from '../Utils/AppApi';
// import { useHistory } from "react-router-dom";
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { API_URL } from '../config';
// import bgshape from './../assets/bgshape.svg';
// import Footer from "./Footer/Footer";
// import OtpInput from "react-otp-input";
// import { isNumber, isNumberKey } from '../Utils/Common';
// import AdvertiseSlider from "./AdvertiseSlider";

// function JoinUs(props) {
//   const history = useHistory()
//   const [step, setStep] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [appInfo, setAppInfo] = useState("");
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [otpValue, setOtpValue] = useState("");
//   const [firstName, setFirstName] = useState("");
//   const [lastName, setLastName] = useState("");
//   const [pancardData, setPancardData] = useState("");

//   const [mPinNumber, setmPinNumber] = useState(null);
//   const mobile = useFormInput('');
//   const pancard = useFormInput('');
//   const refmobile = useFormInput('');
//   const aadhaar = useFormInput('');
//   const outletName = useFormInput('');
//   const email = useFormInput('');

//   const [otpAadharCode, setOtpAadharCode] = useState(0);

//   const [isAadharNumberVerify, setAadharNumberVerify] = useState(false);
//   const [aadharData, setAadharData] = useState("");
//   const [isOtpAadharNumber, setOtpAadharNumber] = useState(false);
//   //   const [error, setError] = useState(null);
//   //   const headers = {
//   //     headers: {
//   //       "appKey": APP_KEY,
//   //     }
//   //   }
//   // handle button click of login form

//   const handleStep1 = () => {
//     const payload = {
//       mobile: mobile.value
//     }
//     setLoading(true);
//     postRequest(MOBILE_VERFIY_SEND, payload, history).then((response) => {
//       if (response.success === true) {
//         toast.success(response.message);
//         // let code = response.message.split("");
//         setStep(step + 1)
//       } else {
//         toast.error(response.message);
//       }
//       setLoading(false);
//     }).catch(function (error) {
//       // console.log(error)
//       setLoading(false);
//     })
//   }

//   const handleStep2 = () => {
//     const payload = {
//       mobile: mobile.value,
//       otp: otpValue
//       // otp : firstOTP.value + secondOTP.value + thirdOTP.value + fourthOTP.value
//     }
//     setLoading(true);
//     postRequest(MOBILE_SEND_VERFIY, payload, history).then((response) => {
//       if (response.success === true) {
//         toast.success(response.message);
//         setStep(step + 1)
//       } else {
//         toast.error(response.message);
//       }
//       setLoading(false);
//     }).catch(function (error) {
//       // console.log(error)
//       setLoading(false);
//     })
//   }

//   const pancardValidation = (text) => {
//     let regex = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
//     if (regex.test(text)) {
//       return true;
//     }
//     return false;
//   }

//   const handleStep3 = () => {
//     if (pancard.value.toUpperCase()) {
//       if (pancardValidation(pancard.value.toUpperCase())) {

//         const payload = { pancard: pancard.value.toUpperCase() };
//         postRequest(`${JOIN_US_PANCARD_VERIFY}`, payload, history).then((response) => {
//           if (response.success === true) {
//             setStep(step + 1);
//             setPancardData(response.data);
//             let checkName = response.data.registered_name.trim();
//             const [first, middle, last] = checkName.split(' ');
//             setFirstName(first);
//             let lastNameAdd = '';
//             if (last) {
//               lastNameAdd = middle + ' ' + last;
//             } else {
//               lastNameAdd = middle;
//             }
//             setLastName(lastNameAdd);
//             toast.success(response.message);
//           } else {
//             toast.error(response.message);
//           }
//         }).catch(function (error) {
//           // console.log(error)
//           // setLoading(false);
//         })
//       } else {
//         toast.error("Pancard number is invalid");
//       }
//     } else {
//       toast.error("Pancard is required");
//     }
//   }

//   const handleStep4 = async () => {
//     // console.log("aadhaar -----------------", aadhaar.value.length)
//     if (aadhaar.value.length === 12) {
//       setLoading(true)
//       const payload = {
//         aadharcard: aadhaar.value,
//         roleId: "P",
//         name: pancardData && pancardData.registered_name
//       };
//       postRequest(`${CREATE_USER_AADHARCARD_VERIFY}`, payload, history).then((response) => {
//         if (response.success) {
//           setOtpAadharNumber(true);
//           setAadharData(response.data);
//           if (response.alreadysuccess) {
//             setAadharNumberVerify(true);
//             setStep(step + 1)
//           }
//           if (!response.alreadysuccess && response.alreadysuccess === "undefined") {
//             toast.warning(response.message);
//           } else {
//             toast.success(response.message);
//           }
//         } else {
//           toast.error(response.message);
//         }
//         setLoading(false);
//       }).catch(function (error) {
//         // console.log(error)
//         setLoading(false);
//       })
//     } else {
//       toast.error("Aadhar number length should be 12 digit")
//     }
//   }

//   const handleVerifyOtpAadharNumber = () => {
//     setLoading(true);
//     const payload = {
//       aadharcard: aadhaar.value,
//       aadharcardOtp: otpAadharCode,
//       ref_id: aadharData && aadharData.ref_id
//     }
//     postRequest(CREATE_USER_AADHARCARD_OTP_VERIFY, payload, history).then((response) => {
//       if (response.success === true) {
//         setOtpAadharNumber(false);
//         setAadharNumberVerify(true);
//         setAadharData(response.data);
//         setStep(step + 1);
//         toast.success(response.message);
//       } else {
//         toast.error(response.message);
//       }
//       setLoading(false);
//     }).catch(function (error) {
//       // console.log(error)
//       setLoading(false);
//     })
//   }

//   const handleStep6 = () => {

//     setLoading(true);
//     let name;
//     if (lastName) {
//       name = firstName + " " + lastName;
//     } else {
//       name = firstName;
//     }
//     const payload = {
//       mobile: mobile.value,
//       pancard: pancard.value.toUpperCase(),
//       refmobile: refmobile.value,
//       firstName: firstName,
//       lastName: lastName,
//       name: name,
//       pancardData: pancardData,
//       email: email.value,
//       outletName: outletName.value,
//       aadharcard: aadhaar.value,
//       aadharNumberVerify: isAadharNumberVerify,
//       aadharData: aadharData,
//       mPin: mPinNumber
//     }
//     postRequest(PARTNER_REGISTER, payload, history).then((response) => {
//       if (response.success === true) {
//         toast.success(response.message);
//         setUsername(response.data.username)
//         setPassword(response.data.password)
//         setStep(step + 1)
//       } else {
//         toast.error(response.message);
//       }
//       setLoading(false);
//     }).catch(function (error) {
//       // console.log(error)
//       setLoading(false);
//     })
//   }

//   const redirectLoginPage = () => {
//     history.push({
//       pathname: "/login"
//     });
//   }

//   const getAppInfo = () => {
//     getRequest(`${API_URL}/appinfo`).then(async (data) => {
//       setLoading(false);
//       if (data) {
//         // console.log("========================", data)
//         await setAppInfo(data)
//       } else {
//         toast.error(data.data.message)
//       }
//     }).catch(function (error) {
//       setLoading(false);
//       console.log(error);
//     })
//   }

//   const handleOTPChange = (otp) => {
//     setOtpValue(otp)
//   }

//   useEffect(() => {
//     getAppInfo()
//   }, []) // eslint-disable-line react-hooks/exhaustive-deps
//   return (
//     <div className='wrapper'>
//       <div className='topbar'>
//         <nav className="main-header navbar navbar-expand navbar-light flex-wrap">
//           <ul className="navbar-nav">
//             <li className="nav-item">
//               <a href="\#" className="brand-link">
//                 <img src="../../logo.png" alt="Logo" className="brand-image" />
//               </a>
//             </li>
//           </ul>

//           <ul className="navbar-nav ml-auto">
//             <li className="nav-item">
//               <a href={`https://wa.me/${appInfo.helpNumber}`} target="_blank" rel="noreferrer" className='nav-link'>
//                 {/* <i className='fas fa-phone-alt mr-1 call-icon'></i> */}
//                 <i class="fa-brands fa-whatsapp fa-fade fa-lg mr-1 call-icon"></i>
//                 <span className='helpline-text'>{appInfo.helpNumber}</span>
//               </a>
//             </li>
//             <li className="nav-item pl-0 pl-md-4">
//               <a href="mailto:{appInfo.email}" className='nav-link'><i className='fas fa-envelope mr-1 call-icon'></i> <span className='helpline-text'>{appInfo.email}</span></a>
//             </li>
//           </ul>
//         </nav>
//       </div>
//       <div className='content-wrapper login-outer' style={{ backgroundImage: `url(${bgshape})`, backgroundRepeat: "no-repeat" }}>
//         <div className='login-container' >
//           <div className=''>
//             <div className='row login-background' >
//               <bgshape />
//               <div className='col-lg-2 text-center'></div>
//               <div className='col-md-6 col-lg-5 text-center'>
//                 <AdvertiseSlider />
//               </div>
//               <div className='col-md-6 col-lg-5'>
//                 <div className="login-box">
//                   <div className="">
//                     <div className="card-body" style={{ textAlign: "center" }}>
//                       {step !== 6 &&
//                         <img src="../../logo.png" alt="Logo" width={"222"} className="brand-image" />
//                       }
//                       {step === 1 && <><h2 className='login-box-heading mt-5 mb-5'>Enter your mobile <br /> number to Continue</h2>
//                         <div className="input-group mb-3">
//                           <input type="text" className="form-control" {...mobile} placeholder="Mobile Number" maxLength={"10"} onKeyPress={() => isNumberKey} />
//                         </div>
//                         <div className="mt-3">
//                           <button type="submit" onClick={() => handleStep1()} className="btn btn-block login-button ">Continue {loading ? "..." : ""}</button>
//                         </div>
//                         <div className="mt-3 join-button px-5 py-1 pointer" onClick={() => redirectLoginPage()}>
//                           <span className='my-1'>Login Now</span>
//                         </div>
//                       </>}

//                       {step === 2 && <><h2 className='login-box-heading mt-5 mb-5'>Enter OTP</h2>
//                         <div className="mb-3 mt-3 otp-justify">
//                           <OtpInput
//                             value={otpValue}
//                             separator={
//                               <span>
//                                 <strong></strong>
//                               </span>
//                             }
//                             onChange={(value) => handleOTPChange(value)}
//                             isInputNum={true}
//                             className="justify-content-md-around"
//                             inputStyle={{
//                               width: "3rem",
//                               height: "3rem",
//                               margin: "0 0.9rem",
//                               fontSize: "2rem",
//                               borderRadius: 4,
//                               border: "1px solid rgba(0,0,0,0.3)"
//                             }}
//                           />
//                         </div>

//                         <div className="mt-5">
//                           <button type="submit" onClick={() => handleStep2()} className="btn btn-block login-button ">Continue {loading ? "..." : ""}</button>
//                         </div></>}

//                       {step === 3 && <><h2 className='login-box-heading mt-5 mb-5'>Enter your pan number</h2>
//                         <div className="input-group mb-3">
//                           <input type="text" className="form-control" {...pancard} placeholder="Pancard number" maxLength={"10"} />
//                         </div>
//                         <div className="input-group mb-3">
//                           <input type="text" className="form-control" {...refmobile} placeholder="Refferal User ID / Mobile Number" maxLength={"10"} />
//                         </div>

//                         <div className="mt-3">
//                           <button type="submit" onClick={() => handleStep3()} className="btn btn-block login-button ">Continue {loading ? "..." : ""}</button>
//                         </div></>}

//                       {step === 4 && <><h2 className='login-box-heading mt-5 mb-5'>Enter your Detail</h2>
//                         <div className="input-group mb-3">
//                           <input type="text" className="form-control" readOnly={true} placeholder="Pancard First Name" value={firstName} />
//                         </div>

//                         <div className="input-group mb-3">
//                           <input type="text" className="form-control" readOnly={true} placeholder="Pancard Last Name" value={lastName} />
//                         </div>

//                         <div className="input-group mb-3">
//                           <input type="text" className="form-control" {...aadhaar} placeholder="Aadhar Number" maxLength={"12"} onKeyPress={() => isNumberKey} />
//                         </div>

//                         {isOtpAadharNumber && !isAadharNumberVerify &&
//                           <div className="input-group">
//                             <div className="col-md-12 mb-3 mt-3 otp-justify">
//                               <OtpInput
//                                 value={otpAadharCode}
//                                 separator={
//                                   <span>
//                                     <strong></strong>
//                                   </span>
//                                 }
//                                 onChange={(value) => setOtpAadharCode(value)}
//                                 isInputNum={true}
//                                 numInputs={6}
//                                 className="justify-content-md-around"
//                                 inputStyle={{
//                                   width: "3rem",
//                                   height: "3rem",
//                                   // margin: "0 0.9rem",
//                                   fontSize: "2rem",
//                                   borderRadius: 4,
//                                   border: "1px solid rgba(0,0,0,0.3)"
//                                 }}
//                               />
//                             </div>
//                           </div>}

//                         {!isOtpAadharNumber ?
//                           <div className="mt-3">
//                             <button type="submit" onClick={() => handleStep4()} className="btn btn-block login-button ">Submit to continue {loading ? "..." : ""}</button>
//                           </div> : <div className="mt-3">
//                             <button type="submit" onClick={() => handleVerifyOtpAadharNumber()} className="btn btn-block login-button ">Submit to continue {loading ? "..." : ""}</button>
//                           </div>
//                         }</>}

//                       {step === 5 && <><div className="mt-3">
//                         {aadharData && aadharData.address && aadharData.name && aadharData.dob && <div className="form-group">
//                           <div className="custom-file">
//                             <ul>
//                               <li>Address: <strong>{aadharData.address}</strong></li>
//                               <li>Aadhar Name: <strong>{aadharData.name}</strong></li>
//                               <li>Date Of Birth: <strong>{aadharData.dob}</strong></li>
//                             </ul>
//                           </div>
//                         </div>}
//                         <div className="input-group mb-3">
//                           <input type="text" className="form-control" {...outletName} placeholder="Outlet Name" />
//                         </div>
//                         <div className="input-group mb-3">
//                           <input type="text" className="form-control" {...email} placeholder="Email Address" />
//                         </div>
//                         <div className="input-group mb-3">
//                           <input type="text" maxLength={4} className={`form-control normal-light `} placeholder="Enter Mpin" onChange={(e) => setmPinNumber(e.target.value)} value={mPinNumber} onKeyDown={(e) => isNumber(e)} />
//                         </div>
//                         <div className="mt-3">
//                           <button type="submit" onClick={() => handleStep6()} className="btn btn-block login-button ">Continue {loading ? "..." : ""}</button>
//                         </div>
//                       </div>
//                       </>}

//                       {step === 6 && <>
//                         <div>
//                           <div className="content-div16">
//                             <img className="vector-icon188" alt={"vector"} src="../../images/vector188.svg" />
//                             <div className="dear-partner-welcome-to-srpay mt-4">
//                               Dear Partner welcome to SR PAY Private Limited Family.
//                             </div>
//                             <div className="your-registration-is-successfull mt-3">
//                               <p className="msg1">
//                                 Your Registration is successfully. Please login using
//                               </p>
//                               <p className="user-id-xxxxx-one-time-pas">
//                                 User ID - <span className="xxxxx-span">{username}</span> &amp; One time Password
//                                 - <span className="xxxxx-span">{password}</span>
//                               </p>
//                             </div>
//                             <div className="my-4">To</div>
//                             <div className="flex-row justify-content-center d-flex" onClick={() => redirectLoginPage()}>
//                               <div className="continue">Continue</div>
//                               <img className="arrow-icon" alt={"arrow"} src="../../images/arrow-1.svg" />
//                             </div>
//                           </div>
//                         </div>
//                       </>}
//                       {step !== 6 &&
//                         <div className="mt-1 text-center">
//                           <p className='forgot'>
//                             By continuing you accept our T&C and Privacy Policy
//                           </p>
//                         </div>
//                       }
//                       <div className='my-4'><hr /></div>
//                       <div className='mb-5 pointer' target="_blank" onClick={() => {
//                         // if (process.env.REACT_APP_SRPAY_LINK === "www.srpay1.com") {
//                         window.open('https://play.google.com/store/apps/details?id=com.srpaypartner', '_blank')
//                         // }
//                       }}>
//                         <img src='../../googleplay1@3x.png' alt='google' width={"213.74"} />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         <ToastContainer position="top-center" autoClose={5000} limit={2} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="colored" />
//       </div>
//       <Footer />
//     </div>
//   );
// }

// const useFormInput = initialValue => {
//   const [value, setValue] = useState(initialValue);
//   const handleChange = e => {
//     setValue(e.target.value);
//   }
//   return {
//     value,
//     onChange: handleChange
//   }
// }

// export default JoinUs;

import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_URL, APP_KEY } from "../config";

function JoinUs() {
  const [isLoading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    mobile: "",
    city: "",
    state: "",
    pincode: "",
    referralMobile: ""
  });

  useEffect(() => {
    // Set page title and meta tags
    document.title = "Join SR PAY - Become a Partner & Start Earning | Register Now";
    
    // Update meta description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute('content', 'Join SR PAY as a retail partner or distributor. Start earning up to ₹50,000/month by offering digital banking, recharge, and bill payment services. Free registration. Instant approval.');
    
    // Update meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', 'join SR PAY, become SR PAY partner, fintech franchise, digital payment agent, earn with SR PAY, retailer registration');
    
    // Canonical link
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://www.srpay1.com/joinus');
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const validate = () => {
    if (!formData.fullName.trim()) {
      toast.error("Please enter full name");
      return false;
    }
    if (!formData.mobile) {
      toast.error("Please enter mobile number");
      return false;
    }
    if (formData.mobile.length !== 10) {
      toast.error("Please enter valid mobile number");
      return false;
    }
    if (formData.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)) {
      toast.error("Please enter valid email");
      return false;
    }
    if (!formData.city.trim()) {
      toast.error("Please enter city");
      return false;
    }
    if (!formData.state.trim()) {
      toast.error("Please enter state");
      return false;
    }
    if (!formData.pincode) {
      toast.error("Please enter pincode");
      return false;
    }
    if (formData.referralMobile && formData.referralMobile.length !== 10) {
      toast.error("Please enter valid referral mobile number");
      return false;
    }
    if (formData.pincode.length !== 6) {
      toast.error("Please enter valid pincode");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    setLoading(true);
    try {
      const response = await axios.post(`${API_URL}/admin/join-now`, formData, {
        headers: {
          appKey: APP_KEY,
          "Content-Type": "application/json",
        },
      });
      if (response.data.success) {
        toast.success(response.data.message);
        setFormData({
          fullName: "",
          email: "",
          mobile: "",
          city: "",
          state: "",
          pincode: "",
          referralMobile: ""
        });
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
    }
    setLoading(false);
  };

  const inputStyle = {
    width: '100%',
    height: '52px',
    borderRadius: '12px',
    padding: '0 20px',
    fontSize: '15px',
    border: '2px solid #E5E7EB',
    outline: 'none',
    transition: 'all 0.3s ease',
    backgroundColor: '#FAFBFC',
    color: '#1A1A2E',
    boxSizing: 'border-box',
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
  };

  return (
    <>
      <div style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #FFF5F5 0%, #FFFBEB 50%, #FFF5F5 100%)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
      }}>
        <div style={{
          width: "100%",
          maxWidth: "480px",
          background: "#fff",
          padding: "40px 35px",
          borderRadius: "24px",
          boxShadow: "0 20px 60px rgba(201, 38, 44, 0.1), 0 5px 20px rgba(0,0,0,0.05)",
          textAlign: "center",
          border: "1px solid rgba(255, 221, 9, 0.2)"
        }}>
          {/* Logo */}
          <img
            src="../../logo.png"
            alt="SR PAY Logo"
            width="170"
            style={{ marginBottom: "8px" }}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
          
          <h2 style={{
            fontSize: "28px",
            fontWeight: "800",
            marginBottom: "6px",
            color: "#1A1A2E",
            letterSpacing: "-0.5px"
          }}>
            Join <span style={{ 
              background: "linear-gradient(135deg, #C9262C, #FF8C00)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text"
            }}>SR PAY</span>
          </h2>
          
          <p style={{
            color: "#6B7280",
            fontSize: "14px",
            marginBottom: "30px",
            lineHeight: "1.5"
          }}>
            Start your digital financial services business today
          </p>

          {/* Form Fields */}
          <input 
            type="text" 
            name="fullName" 
            value={formData.fullName} 
            placeholder="Full Name *" 
            style={inputStyle} 
            onChange={handleChange}
            onFocus={(e) => { e.target.style.borderColor = '#C9262C'; e.target.style.backgroundColor = '#FFF'; }}
            onBlur={(e) => { e.target.style.borderColor = '#E5E7EB'; e.target.style.backgroundColor = '#FAFBFC'; }}
          />
          <div style={{ height: '14px' }} />

          <input 
            type="email" 
            name="email" 
            value={formData.email} 
            placeholder="Email Address (Optional)" 
            style={inputStyle} 
            onChange={handleChange}
            onFocus={(e) => { e.target.style.borderColor = '#C9262C'; e.target.style.backgroundColor = '#FFF'; }}
            onBlur={(e) => { e.target.style.borderColor = '#E5E7EB'; e.target.style.backgroundColor = '#FAFBFC'; }}
          />
          <div style={{ height: '14px' }} />

          <input 
            type="number" 
            name="mobile" 
            value={formData.mobile} 
            placeholder="Mobile Number *" 
            style={inputStyle} 
            onChange={handleChange}
            onFocus={(e) => { e.target.style.borderColor = '#C9262C'; e.target.style.backgroundColor = '#FFF'; }}
            onBlur={(e) => { e.target.style.borderColor = '#E5E7EB'; e.target.style.backgroundColor = '#FAFBFC'; }}
          />
          <div style={{ height: '14px' }} />

          <input 
            type="number" 
            name="referralMobile" 
            value={formData.referralMobile} 
            placeholder="Referral Mobile (Optional)" 
            style={inputStyle} 
            onChange={handleChange}
            onFocus={(e) => { e.target.style.borderColor = '#C9262C'; e.target.style.backgroundColor = '#FFF'; }}
            onBlur={(e) => { e.target.style.borderColor = '#E5E7EB'; e.target.style.backgroundColor = '#FAFBFC'; }}
          />
          <div style={{ height: '14px' }} />

          <div style={{ display: 'flex', gap: '12px' }}>
            <input 
              type="text" 
              name="city" 
              value={formData.city} 
              placeholder="City *" 
              style={{ ...inputStyle, flex: 1 }} 
              onChange={handleChange}
              onFocus={(e) => { e.target.style.borderColor = '#C9262C'; e.target.style.backgroundColor = '#FFF'; }}
              onBlur={(e) => { e.target.style.borderColor = '#E5E7EB'; e.target.style.backgroundColor = '#FAFBFC'; }}
            />
            <input 
              type="text" 
              name="state" 
              value={formData.state} 
              placeholder="State *" 
              style={{ ...inputStyle, flex: 1 }} 
              onChange={handleChange}
              onFocus={(e) => { e.target.style.borderColor = '#C9262C'; e.target.style.backgroundColor = '#FFF'; }}
              onBlur={(e) => { e.target.style.borderColor = '#E5E7EB'; e.target.style.backgroundColor = '#FAFBFC'; }}
            />
          </div>
          <div style={{ height: '14px' }} />

          <input 
            type="number" 
            name="pincode" 
            value={formData.pincode} 
            placeholder="Pincode *" 
            style={inputStyle} 
            onChange={handleChange}
            onFocus={(e) => { e.target.style.borderColor = '#C9262C'; e.target.style.backgroundColor = '#FFF'; }}
            onBlur={(e) => { e.target.style.borderColor = '#E5E7EB'; e.target.style.backgroundColor = '#FAFBFC'; }}
          />
          <div style={{ height: '24px' }} />

          {/* Submit Button */}
          <button
            onClick={handleSubmit}
            disabled={isLoading}
            style={{
              width: "100%",
              height: "52px",
              border: "none",
              borderRadius: "14px",
              background: isLoading 
                ? "#D1D5DB" 
                : "linear-gradient(135deg, #C9262C 0%, #E8454B 50%, #C9262C 100%)",
              backgroundSize: "200% 100%",
              color: "#fff",
              fontSize: "16px",
              fontWeight: "700",
              cursor: isLoading ? "not-allowed" : "pointer",
              transition: "all 0.3s ease",
              boxShadow: isLoading ? 'none' : "0 8px 25px rgba(201, 38, 44, 0.3)",
              animation: isLoading ? 'none' : 'gradientShift 3s ease infinite',
              letterSpacing: "0.5px"
            }}
            onMouseOver={(e) => {
              if (!isLoading) {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = "0 15px 35px rgba(201, 38, 44, 0.4)";
              }
            }}
            onMouseOut={(e) => {
              if (!isLoading) {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = "0 8px 25px rgba(201, 38, 44, 0.3)";
              }
            }}
          >
            {isLoading ? (
              <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                <span style={{ 
                  width: '20px', 
                  height: '20px', 
                  border: '2px solid rgba(255,255,255,0.3)', 
                  borderTopColor: 'white', 
                  borderRadius: '50%',
                  animation: 'spin 0.8s linear infinite',
                  display: 'inline-block'
                }} />
                Processing...
              </span>
            ) : "Submit Request"}
          </button>

          <p style={{ 
            marginTop: '20px', 
            fontSize: '12px', 
            color: '#9CA3AF',
            lineHeight: '1.5'
          }}>
            By submitting, you agree to our Terms & Conditions and Privacy Policy
          </p>
        </div>
      </div>

      {/* Animation Styles */}
      <style>{`
        @keyframes gradientShift {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
        input[type="number"]::-webkit-inner-spin-button,
        input[type="number"]::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        input[type="number"] {
          -moz-appearance: textfield;
        }
      `}</style>

      <ToastContainer position="top-center" autoClose={3000} theme="colored" />
    </>
  );
}

export default JoinUs;